import { render, staticRenderFns } from "./ParticipantScoreChart.vue?vue&type=template&id=3089a292"
import script from "./ParticipantScoreChart.vue?vue&type=script&lang=js"
export * from "./ParticipantScoreChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports